import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { ProfileModule } from '@app/modules/profile/profile.module'

@Component({
  selector: 'sb-message-wrapper',
  templateUrl: './message-wrapper.component.html',
  styleUrls: ['./message-wrapper.component.scss'],
  imports: [ProfileModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageWrapperComponent {
  @Input({ required: true }) messageType!: 'sent' | 'received'
  @Input({ required: true }) photoUrl!: string
}
